module.exports = __webpack_public_path__ + "static/media/lecho.9210ad8c.png";